<template lang="">
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        Loading...
    </div>
    <div class="container-fluid py-5">
        <div class="box top-box mb-3 p-4 rounded-3 bg-white d-flex align-items-center shadow">
            <h4 class="font-weight-bold">Warehouse Dashboard</h4>
        </div>
        <!-- Button group -->
        <!-- <div class="d-flex">
            
            <div class="mr-3 custom-date-box shadow"> -->
                <!--@update:model-value="fetchDataByDate"-->
                <!-- <vue-datepicker v-model="date" range placeholder="Start Typing ..."
                    :text-input="textInputOptions" :is-24="false" :enable-time-picker="false"></vue-datepicker>
                
            </div>
            <div class="d-flex mr-3">
                <p class="black font-weight-bold mt-3 mr-3">STATUS</p>
                <select class="custom-invo-input form-select mt-2 shadow" v-model="selectedStatus" title="Status"> -->
                    <!-- 출고지 옵션을 동적으로 렌더링 -->
                    <!-- <option  v-for="(status, index) in statusOptions" :key="index" :value="status.value">{{ status.name }}</option>
                </select>
            </div>
            <v-btn prepend-icon="mdi-magnify" class="mt-2 mr-3" @click="fetchDataByFilter">Inquiry</v-btn>
            
        </div> -->
        <v-card class="mt-1">
        
            <v-tabs v-model="tab" color="deep-purple-accent-4">
                <v-tab value="1">Warehouse Table</v-tab>
                <!-- <v-tab value="2">Shipping</v-tab> -->
                <!-- <v-tab value="9">Completed</v-tab> -->
            </v-tabs>
            
    
            <v-card-text>
                
                <v-window v-model="tab">
                    <v-window-item value="1">
                        <div class="d-flex mb-3">
                            <vue-datepicker v-model="date" range placeholder="Start Typing ..."
                        :text-input="textInputOptions" :is-24="false" :enable-time-picker="false"></vue-datepicker>
                        <v-btn prepend-icon="mdi-magnify" class="ml-5" @click="fetchInItemQty">Inquiry</v-btn>
                        </div>
                        <v-select :items="Object.values(warhsValues)" v-model="selectedWarhs" label="창고별 필터"
                            @update:modelValue="filterItems" class=""></v-select>

                        <v-text-field
                            v-model="search"
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            variant="outlined"
                            hide-details
                            >   
                        </v-text-field>
                        <v-data-table
                            :items-per-page="itemsPerPage"
                            :custom-filter="filterOnlyCapsText"
                            :headers="headers"
                            :items="items"
                            :search="search"
                            item-value="name"
                            class="custom-min-height"
                            >
                            <!-- <template v-slot:top>
                                
                            </template> -->
                            <template #[`item`]="{ item }">
                                <tr class="data-table-row">
                                    <td class="text-start">{{ items.indexOf(item) + 1 }}</td>
                                    <td class="text-center">{{ this.warhsValues[item.WARHS.trim()]}}</td>
                                    <td class="custom-class text-center font-weight-black">{{ item.ITMNO }}</td>
                                    <td class="text-center">{{ item.ITMDES }}</td>
                                    <td class="text-end">
                                        {{ item.GIBN_QTY }}
                                    </td>
                                    <td class="text-end text-green-darken-1">{{ item.YIPGO_QTY }}</td>
                                    <td class="text-end text-red-darken-1">
                                        {{ item.CULGO_QTY }}
                                    </td>
                                    <td class="text-end">
                                        {{ item.GIMAL_QTY }}
                                    </td>
                                    <td class="text-end">
                                        {{ item.ONHND_QTY }}
                                    </td>
                                </tr>
                            </template>

</v-data-table>
</v-window-item>

</v-window>
</v-card-text>
</v-card>
</div>
</template>
<script>
import axios from 'axios';
import VueDatepicker from '@vuepic/vue-datepicker';
export default {
    components: {
        VueDatepicker,
    },
    data() {
        return {
            tab: null,
            search: '',
            originItems: [],
            warhsValues: {
                'All': 'All',
                'AA': '1공장 라인',
                'AB': '1공장 창고',
                'AE': '1공장 홀딩',
                'BA': '2공장 라인',
                'BB': '2공장 창고',
                'BE': '2공장 홀딩',
                'C01': 'C01',
                'C02': 'C02',
                'C03': 'C03',
                'C04': 'C04',
                'C71': 'C71',
                'F01': 'F01',
                'F02': 'F02',
                'F04': 'F04',
                'F05': 'F05',
                'R01': 'R01',
                'R02': 'F02',
                'R03': 'R03',
                'R04': 'R04',
                'R06': 'R06',
                
                
            },
            headers: [
                {
                    title: 'No',
                    align: 'start',
                    key: ''
                },
                {
                    title: '창고',
                    align: 'center',
                    key: 'WARHS'
                },
                {
                    title: '품번',
                    align: 'center',
                    key: 'ITMNO'
                },
                {
                    title: '품명',
                    align: 'center',
                    key: 'ITMDES'
                },
                {
                    title: '기초재고',
                    align: 'end',
                    key: 'GIBN_QTY'
                },
                {
                    title: '입고',
                    align: 'end',
                    key: 'YIPGO_QTY'
                },
                {
                    title: '출고',
                    align: 'end',
                    key: 'CULGO_QTY'
                },
                {
                    title: '기말재고',
                    align: 'end',
                    key: 'GIMAL_QTY'
                },
                {
                    title: '현재고',
                    align: 'end',
                    key: 'ONHND_QTY'
                },
            ],
            selectedWarhs: null,
            loading: false,
            items: [],
            date: null,
            itemsPerPage: 100,
        };
    },
    computed: {

    },
    methods: {
        filterItems() {
            if (this.items.length != 0) {
                if (this.selectedWarhs == 'All') {
                    this.items = this.originItems
                } else {
                    //console.log(this.selectedWarhs)
                    const convertedWarhs = Object.keys(this.warhsValues).find(key => this.warhsValues[key] === this.selectedWarhs)
                    //console.log(convertedWarhs)
                    this.items = this.originItems.filter(item => item.WARHS.trim() === convertedWarhs);
                    //console.log(this.items);
                }

            }



        },
        // 출고처리할 데이터 가져오는 메서드
        async fetchInItemQty() {
            this.loading = true;
            try {
                if (this.date != null) {
                    const startDay = this.date[0].getFullYear() + String(this.date[0].getMonth() + 1).padStart(2, '0')
                        + String(this.date[0].getDate()).padStart(2, '0');
                    const endDay = this.date[1].getFullYear() + String(this.date[1].getMonth() + 1).padStart(2, '0')
                        + String(this.date[1].getDate()).padStart(2, '0');
                    const response = await axios.get('/api/getMaterialQty', {
                        params: {
                            startDate: startDay,
                            endDate: endDay
                        }
                    });
                    //console.log('check', response.data)
                    if (response.data.err) {
                        //console.log(response.data.err);
                    } else if (response.data.message) {
                        //console.log(response.data.message);
                    } else {
                        //console.log(response.data);
                        this.originItems = response.data;

                        this.items = response.data;
                    }
                } else {
                    alert("Select the date!");
                }


            } catch (err) {
                console.error('Data fetch error: ', err);
            }
            this.loading = false;

        },
        isNumericChar(char) {
            return !isNaN(parseFloat(char)) && isFinite(char);
        }


    }
}
</script>
<style scoped>
.custom-min-height {
    min-height: 400px;
}

.vertical-align {
    vertical-align: middle;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 9999;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    z-index: 9999;
    animation: spin 1s linear infinite;
}

.data-table-row:hover {
    background-color: #f5f5f5;
    /* 마우스 오버 시 배경색 변경 */
    cursor: pointer;
}
</style>